<div
  appInView
  (inView)="onCommentScrolledInView(comment)"
  class="comments"
  *ngFor="let comment of comments; let first = first; let last = last"
  [ngClass]="{
    'mt-auto': first && comments?.length < 5,
    'mb-4': !last,
  }">
  <div class="comment" [innerHTML]="comment.comment"></div>
  <div class="comment-info-container">
    <app-user-profile-badge
      [initials]="comment?.author?.initials"
      [profileBadgeConfiguration]="comment?.author?.profileBadgeConfiguration" />
    <span class="comment-info comment-name"> {{ comment?.author?.firstName }} {{ comment?.author?.lastName }} </span>
    <span class="comment-info">{{ comment?.formattedDate }}</span>
  </div>
  <div *ngIf="visibilityLabel && comment?.isVisibleExternally" class="visibility-badge">
    <img src="assets/icons/dark/Eye On.svg" alt="" class="visibility-icon" />
    <span>{{ visibilityLabel }}</span>
  </div>
</div>
